import React from "react";
import Select from "react-select";

class CustomMultiSelect extends React.Component {
  constructor(props) {
    super(props);
    
    this.onChange = this.onChange.bind(this);
  }

  onChange(data) {
    const { name, setFieldValue } = this.props;
    
    setFieldValue(name, data);
  }

  validateField = value => {
    let error;
    const { required } = this.props;
    if (required && !value) {
      error = "This field is required";
    }
    return error;
  };

  render() {
    const { name, placeholder, options, value, isClearable } = this.props;

    return (
      <React.Fragment>
        <Select
          classNamePrefix="select"
          placeholder={placeholder || "Please select"}
          name={name}
          options={options}
          isMulti
          isClearable={isClearable === true?true:false}
          {...this.props}
          onChange={this.onChange}
          value={value}
        />
      </React.Fragment>
    );
  }
}

export default (CustomMultiSelect);